import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

export const EditableTemplateName = ({
  template,
  hasEditAccess,
  onEditClick,
  onDeleteClick,
  isDeleting = false,
}) => {
  const structure = template?.items?.structure;
  const sourceTab = structure?.source?.tab;
  const status = structure?.status;
  const summary = (
    <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-gray-500">
      {status && <span className={`rounded px-2 py-0.5 font-medium ${status === 'PUBLISHED' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`}>{status === 'PUBLISHED' ? 'Published' : 'Draft'}</span>}
      {sourceTab && <span>Sheet: {sourceTab}</span>}
    </div>
  );
  if (!hasEditAccess) {
    return (
      <div className="px-4 py-3 bg-white rounded-lg border border-gray-200">
        <h3 className="text-base font-semibold text-gray-900">{template?.name}</h3>
        {summary}
      </div>
    );
  }

  return (
    <div className="group relative px-4 py-3 bg-white rounded-lg border border-gray-200 hover:border-gray-300 hover:shadow-sm transition-all duration-200">
      <div className="flex items-center justify-between gap-3 py-[0.20rem]">
        <div className="min-w-0 flex-1">
          <h3 className="text-base font-semibold text-gray-900">{template?.name}</h3>
          {summary}
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => onEditClick?.(template)}
            className="group-hover:opacity-100 transition-opacity duration-200 p-1.5 rounded-md hover:bg-gray-100 text-gray-500 hover:text-gray-700"
            aria-label="Edit template"
            disabled={isDeleting}
          >
            <PencilIcon className="h-4 w-4" />
          </button>
          <button
            onClick={() => onDeleteClick?.(template)}
            disabled={isDeleting}
            className={`transition-all duration-200 p-1.5 rounded-md text-red-500 hover:text-red-700 hover:bg-red-50 ${
              isDeleting ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            aria-label="Delete template"
          >
            <TrashIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
